export const employeeNotFound = 'Nenhum funcionário encontrado para o período!';
export const generalError = 'Ocorreu um erro, por favor tente novamente.';
